import { mobileDeviceFullStore } from '../store/store';
import { toggleDeviceLoggingWindow } from '../mutators/toggleDeviceLoggingWindow';
import { markIsDevicesDirty } from '../mutators/markIsDevicesDirty';
import { markIsNotSendReadReceiptDirty } from '../mutators/markIsNotSendReadReceiptDirty';
import { markIsLoggingEnabledDirty } from '../mutators/markIsLoggingEnabledDirty';
import { setCASMailbox } from '../services/setCASMailbox';
import { removeMobileDevice } from '../services/removeMobileDevice';

export async function onSaveMobileOption(): Promise<void> {
    let store = mobileDeviceFullStore();

    if (store.isLoggingEnabledDirty) {
        await setCASMailbox(store.isLoggingEnabled);
        toggleDeviceLoggingWindow();
        markIsLoggingEnabledDirty(false);
    } else if (store.isNotSendReadReceiptDirty) {
        await setCASMailbox(undefined, store.notSendReadReceipt);
        markIsNotSendReadReceiptDirty(false);
    } else if (store.isDevicesDirty) {
        for (let index = 0; index < store.deviceStatistics.length; index++) {
            let found = false;

            for (let device of store.devices) {
                if (
                    store.deviceStatistics[index].Identity.RawIdentity ===
                    device.identity.RawIdentity
                ) {
                    found = true;
                }
            }

            if (!found) {
                await removeMobileDevice(store.deviceStatistics[index].Identity);
            }
        }

        markIsDevicesDirty(false);
    }
}
